import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import {
  useLocalStorage,
} from "../../hooks/useLocalStorage";
import { useEffect, useState } from "react";
import mammoth from "mammoth";

interface Props {
  open: boolean;
  handleClose: (hasFinished?: boolean) => void;
}

const TermsOfUseDialog: React.FC<Props> = ({ open, handleClose }) => {
  const [htmlContent, setHtmlContent] = useState("");
  const [, setTermsOfUseStorage] = useLocalStorage("termsOfUse", "");
  const [, setSeenTermsOfUse] = useLocalStorage("seenTermsOfUse", "");

  function handleAccept() {
    setTermsOfUseStorage("true");
    setSeenTermsOfUse("true");

    handleClose(true);
  }

  function transformDocument(element: any) {
    if (element.children) {
      element.children.forEach(transformDocument);
    }

    if (element.type === "paragraph") {
      if (element.indent.start) {
        element.styleName = "ident-start";
      }
    }

    if (element.type === "run") {
      const child = element.children[0];

      const titleReg = /^\d*\. /;

      const isElementTitle = child.value.match(titleReg);
      const isElementLink = child.value.includes("www.abb.com/integrity");

      if (isElementLink) {
        element.type = "hyperlink";
        element.href = "www.abb.com/integrity";
        element.styleName = "link";
      }

      if (isElementTitle) {
        element.isBold = true;
      }
    }
    return element;
  }

  async function getTermsAndConditions() {
    const response = await fetch("/terms_and_conditions.docx");
    const arrayBuffer = await response.arrayBuffer();

    const options = {
      transformDocument,
      styleMap:
        "p[style-name='ident-start'] => p.indent-start:fresh\n" +
        "r[style-name='link'] => a.link-red:fresh",
    };

    const result = await mammoth.convertToHtml({ arrayBuffer }, options);

    setHtmlContent(result.value);
  }

  useEffect(() => {
    getTermsAndConditions();
  }, []);

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      scroll={"paper"}
      sx={{
        "& .MuiPaper-root": {
          width: "606px",
          minHeight: "367px",
          padding: "32px 24px",
        },
      }}
      aria-labelledby="terms-of-use-dialog-title"
      aria-describedby="terms-of-use-dialog-description"
    >
      <DialogTitle component="div" sx={{ padding: "0" }}>
        <Typography
          id="terms-of-use-dialog-title"
          variant="h4"
          className="red-bar"
          pt="12px"
        >
          Terms and Conditions
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 0, my: "32px" }}>
        <Box
          maxHeight="518px"
          overflow="auto"
          padding="24px 0"
          className="abb-scroll"
        >
          <Typography id="terms-of-use-dialog-description" variant="h6" mb={2}>
            ABB GENERAL TERMS AND CONDITIONS FOR PURCHASE OF GOODS AND/OR
            SERVICES (2024-2 STANDARD)
          </Typography>

          <Typography
            variant="bodySmallWeightRegular"
            sx={{ whiteSpace: "pre-wrap", textAlign: "justify" }}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: 0 }}>
        <Stack direction="row" spacing="16px">
          <Button variant="containedAbb" onClick={handleAccept}>
            Accept
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default TermsOfUseDialog;
